import React from 'react';
import { SectionHeader } from '@grnhse/seedling/lib/birch/typography';
import { Row } from '@grnhse/seedling/lib/birch/layouts/row';
import { withLocalePrefix } from '../shared/utils/translation';
import { LogoContainer } from './styled_components';

const t = withLocalePrefix('authorization.authorization_form');

type Props = {
  name: string;
  companyLogoUrl: string;
};

export default function ConsentHeader({ name, companyLogoUrl }: Props) {
  return (
    <Row spacing={3} justifyContent="space-between">
      <SectionHeader>
        {t('title.authorize')} <strong>{name}</strong>{' '}
        {t('title.to_use_GH_account')}
      </SectionHeader>
      {companyLogoUrl && (
        <LogoContainer>
          <img src={companyLogoUrl} alt={name} />
        </LogoContainer>
      )}
    </Row>
  );
}
